import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { DateTime } from 'luxon';
import { Draft } from '../db/Draft.js';
import { sendAssigneeChangeNotification } from '../server/sendAssigneeChangeNotification.js';
import { sendStatusChangeNotification } from '../server/sendStatusChangeNotification.js';

export const saveRawDraft = registerQuery({
  type: () => String,
  operationName: 'saveRawDraft',
  resolve: (draft: Draft) => {
    return async () => {
      draft.updatedAt = DateTime.now();

      const rawCollection = await getRawCollection<Draft>(Draft._collectionName);

      const oldDraft = await rawCollection.findOne({ _id: draft._id });
      if (!oldDraft) throw new Error('You can only save drafts that you have created');
      // @ts-ignore
      await rawCollection.updateOne({ _id: draft._id }, { $set: draft.toObject() });

      // 1. check if status has changed
      if (oldDraft.status?.name !== draft.status?.name) {
        await sendStatusChangeNotification(draft);
      }

      // 2. check if assignee has changed
      if (oldDraft.assignedDesigner !== draft.assignedDesigner) {
        await sendAssigneeChangeNotification(oldDraft.assignedDesigner, draft.assignedDesigner, draft);
      }

      if (oldDraft.assignedReviewer !== draft.assignedReviewer) {
        await sendAssigneeChangeNotification(oldDraft.assignedReviewer, draft.assignedReviewer, draft);
      }
    };
  },
  params: [{ name: 'draft', type: () => Draft }],
});
